module.exports = __webpack_public_path__ + "77257411bae786bb46761dcb62b47f0e.jpg"


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/labels/headers/soundway.jpg
 ** module id = 428
 ** module chunks = 0
 **/